const SearchPageType = {
  SEARCH_RESULT: 'search-result-page',
  LIPA_SEARCH_RESULT: 'lipa-search-result-page',
  EXPOSE: 'expose-page',
  DEVELOPMENT_EXPOSE: 'development-expose-page',
  ERROR: '404-page',
} as const;

const OtherPageTypes = {
  HOME: 'homepage',
  RENTER: 'renter-page',
  COMPANY: 'company-page',
  CONTENT: 'content-page',
  LEGAL: 'legal-page',
  SELLER: 'seller-page',
  VALUATION: 'valuation-page',
  SHOP_PROFILE: 'shop-profile-page',
  SHOP_FINDER: 'shop-finder-page',
  ADVISOR_FINDER: 'advisor-finder-page',
  AGENT_RECRUITING: 'agent-recruiting-page',
  CAREER: 'career-page',
  AGENT_PROFILE: 'agent-profile-page',
  CAMPAIGN: 'campaign-page',
  ARTICLE: 'article-page',
  ARTICLE_OVERVIEW: 'article-overview-page',
  FRANCHISE_ACQUISITION: 'franchise-acquisition-page',
  DOI_CONFIRM: 'doi-confirm-page',
  ERROR_PAGE: 'error-page',

  AGENT: 'agent-page',
  BUYER: 'buyer-page',

  COUNTRY: 'country-page',
  STATE: 'state-page',
  CITY: 'city-page',
  DISTRICT: 'district-page',
} as const;

const SearchTemplateType = {
  SEARCH_RESULT: 'search-result-page',
  EXPOSE: 'expose-page',
  ERROR: '404-page',
} as const;

const AutogenTemplateType = {
  BUYER: 'buyer-page',
  AGENT: 'agent-page',
} as const;

export const PageType = { ...SearchPageType, ...OtherPageTypes };

export type PageType = (typeof PageType)[keyof typeof PageType];

export const TemplateType = { ...SearchTemplateType, ...AutogenTemplateType };

export type TemplateType = (typeof TemplateType)[keyof typeof TemplateType];

export type PageTrackingTypes = {
  pageType: PageType;
  templateType: TemplateType;
};
